module.exports = __webpack_public_path__ + "assets/img/service-QRcord-fyq.943956dd.jpg";